module.exports = __webpack_public_path__ + "img/sign2.1641520899224.png";